import { render, staticRenderFns } from "./examlist.vue?vue&type=template&id=c533b6b6"
import script from "./examlist.vue?vue&type=script&lang=js"
export * from "./examlist.vue?vue&type=script&lang=js"
import style0 from "./examlist.vue?vue&type=style&index=0&id=c533b6b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports